<template>
  <div class="care-phone">
    <div class="care-phone__main">
      <div class="care-phone__content">
        <video
          class="care-phone__video"
          :src="isMobile ? '/media/video/care/section-2-m.mp4' : '/media/video/care/section-2.mp4'"
          muted
          playsinline
          loop
        />
        <video
          class="care-phone__video"
          :src="isMobile ? '/media/video/care/section-3-m.mp4' : '/media/video/care/section-3.mp4'"
          muted
          playsinline
          loop
        />
        <video
          class="care-phone__video"
          :src="isMobile ? '/media/video/care/section-4-m.mp4' : '/media/video/care/section-4.mp4'"
          muted
          playsinline
          loop
        />
        <img
          class="care-phone__img"
          :src="isMobile ?
          '/media/img/products/care/section-5-3-m.jpg'
          : '/media/img/products/care/section-5-3.jpg'"
        />
      </div>
    </div>
    <div class="care-phone__shadow" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CarePhone',
  props: {
    sectionIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
    }),
  },
  watch: {
    sectionIndex(value) {
      if (value === 4) return;
      const videos = document.querySelectorAll('.care-phone video');
      if (value === 0 || value === 1) {
        videos[0].currentTime = 0;
        videos[0].play();
        return;
      }
      videos[value - 1].currentTime = 0;
      videos[value - 1].play();
      if (value === 3) {
        const uiVideo = document.querySelector('.care-sleep-section__video video');
        uiVideo.currentTime = 0;
        uiVideo.play();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.care-phone
  position: absolute
  top: 50%
  left: 50%
  width: 320px
  transform: translate3d(-50%, -50%, 0px)
  pointer-events: none
  transition: all 1s ease-in-out
  z-index: 1

  @media screen and (max-width: 1440px)
    width: 240px

  @media screen and (max-width: 1024px)
    width: 200px

  @media screen and (orientation: portrait), (max-width: 768px)
    top: 60px;
    left: auto
    right: 32px
    transform: none

    .page-care__scroll.active-3 &,
    .page-care__scroll.active-4 &
      right: 50%
      transform: translate3d(50%, 0px, 0px)

  @media screen and (max-width: 414px)
    width: 170px

  @media screen and (max-width: 375px)
    width: 150px

  @media screen and (orientation: portrait), (max-width: 768px)

    .page-care__scroll.active-4 &
      right: 50%
      transform: translate3d(70%, 25%, 0px) scale(0.8)

  &::after
    position: relative
    content: ''
    display: block
    padding-bottom: 202.29%

  > *
    position: absolute
    top: 0
    left: 0

  video
    width: 100%
    height: 100%

    &:nth-of-type(3)
      transform: translateY(-12px) scale(1.96) rotate(90deg)

    &:nth-of-type(2)
      @media screen and (orientation: portrait), (max-width: 768px)
        transition: opacity 0.5s ease-in-out
        .page-care__scroll.active-3 &
          opacity: 0

    &:nth-of-type(3)
      @media screen and (orientation: portrait), (max-width: 768px)
        opacity: 0
        transition: opacity 0.5s ease-in-out
        transform: translateY(-100%) translateY(-12px) scale(1.96) rotate(90deg)

        .page-care__scroll.active-3 &,
        .page-care__scroll.active-4 &
          opacity: 1

  img
    width: 100%
    transform: translate(-100%, -267%) scale(1.96) rotate(90deg)

    @media screen and (orientation: portrait), (max-width: 768px)
      transform: translate(-100%, -687%) scale(1.96) rotate(90deg)

  &__main
    width: 100%
    height: 100%
    display: flex
    align-items: center
    border-radius: 55px
    justify-content: center
    overflow: hidden
    transform-origin: right top
    transition: transform 1s .5s ease-in-out
    isolation: isolate;
    padding-top: 30px
    background: #f5f5f5

    .page-care__scroll.active-3 &,
    .page-care__scroll.active-4 &
      padding-top: 0

    @media screen and (max-width: 1440px)
      border-radius: 42px
      padding-top: 22px

    @media screen and (max-width: 1024px)
      border-radius: 35px

    @media screen and (max-width: 414px)
      border-radius: 30px
      padding-top: 13px

    &::after
      content: ''
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background: url('/media/img/products/care/phone-w480.png') no-repeat center / cover
      transform: translateZ(0px)
      transition: background 1s ease-in-out

    .page-care__scroll.active-3 &,
    .page-care__scroll.active-4 &
        transform: translateX(-100%) scale(1.25) rotate(-90deg)

        &::after
          background-image: url('/media/img/products/care/phone-2-w480.png')

        @media screen and (orientation: portrait), (max-width: 768px)
          transform: translateX(-150%) rotate(-90deg)

  &__content
    width: 100%
    height: 100%
    transition: transform 1s ease-in-out
    background: white

    @media screen and (orientation: portrait), (max-width: 768px)
      .page-care__scroll.active-4 &
        transition: transform .5s ease-in-out

    .page-care__scroll.active-2 &
      transform: translateY(-100%)

    .page-care__scroll.active-3 &
      transform: translateY(-200%)

      @media screen and (orientation: portrait), (max-width: 768px)
        transform: translateY(-100%)

    .page-care__scroll.active-4 &
      transform: translate(100%, -200%)

      @media screen and (orientation: portrait), (max-width: 768px)
        transform: translate(100%, -100%)

  &__shadow
    width: 970px
    height: 970px;
    border-radius: 50%;
    background: linear-gradient(to bottom, rgba(123, 123, 123, 1) -6.12%, transparent 34.38%);
    top: 50%
    left: 50%
    transform: translate(-50%, -20%) translateX(25%)
    opacity: 0
    transition: opacity 0.6s
    z-index: -1

    @media screen and (max-width: 1440px)
      max-width: 770px
      max-height: 770px;

    @media screen and (max-width: 1024px)
      max-width: 610px
      max-height: 610px;

    @media screen and (orientation: portrait), (max-width: 768px)
      display: none

    .page-care__scroll.active-3 &,
    .page-care__scroll.active-4 &
      transition: opacity 0.6s 1s ease-in-out
      opacity: 1

    @media screen and (orientation: portrait), (max-width: 375px)
      .page-care__scroll.active-4 &
        opacity: 0

</style>
